export default __webpack_public_path__ + "static/media/bagIcon.02c2eab2.svg";